import m from "../../geodata/es2015/zambiaLow";
window.am4geodata_zambiaLow = m;


//////////////////
// WEBPACK FOOTER
// ./geodata/zambiaLow.js
// module id = null
// module chunks = 